import { push } from 'connected-react-router'

export const createAccountAction = createAccountLink => dispatch => dispatch(push(createAccountLink))
